//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TreeNode from "./TreeNode.vue";

export default {
	name: 'FileBrowser',
	components: {
		TreeNode
	},
	data() {
		return {
			node: {
				label: __('Home'),
				value: 'Home',
				children: [],
				is_leaf: false,
				fetching: false,
				fetched: false,
				open: false,
				filtered: true
			},
			selected_node: {},
			filter_text: ''
		}
	},
	mounted() {
		this.toggle_node(this.node);
	},
	methods: {
		toggle_node(node) {
			if (!node.fetched && !node.is_leaf) {
				node.fetching = true;
				this.get_files_in_folder(node.value)
					.then(files => {
						node.open = true;
						node.children = files;
						node.fetched = true;
						node.fetching = false;
					});
			} else {
				node.open = !node.open;
				this.select_node(node);
			}
		},
		select_node(node) {
			if (node.is_leaf) {
				this.selected_node = node;
			}
		},
		get_files_in_folder(folder) {
			return daffy.call('daffy.core.doctype.file.file.get_files_in_folder', { folder })
				.then(r => {
					let files = r.message || [];
					files.sort((a, b) => {
						if (a.is_folder && b.is_folder) {
							return a.modified < b.modified ? -1 : 1;
						}
						if (a.is_folder) {
							return -1;
						}
						if (b.is_folder) {
							return 1;
						}
						return 0;
					});
					return files.map(file => {
						let filename = file.file_name || file.name;
						return {
							label: daffy.utils.file_name_ellipsis(filename, 40),
							filename: filename,
							file_url: file.file_url,
							value: file.name,
							is_leaf: !file.is_folder,
							fetched: !file.is_folder, // fetched if node is leaf
							children: [],
							open: false,
							fetching: false,
							filtered: true
						}
					});
				});
		},
		apply_filter: daffy.utils.debounce(function() {
			let filter_text = this.filter_text.toLowerCase();
			let apply_filter = (node) => {
				let search_string = node.filename.toLowerCase();
				if (node.is_leaf) {
					node.filtered = search_string.includes(filter_text);
				} else {
					node.children.forEach(apply_filter);
				}
			}
			this.node.children.forEach(apply_filter);
		}, 300)
	}
}
